export interface UserFeature {
    firstPartyAccess: boolean;
    aneida: boolean;
    chat: boolean;
    beta: boolean;
}

export const defaultFeatures: UserFeature = {
    firstPartyAccess: false,
    aneida: false,
    chat: false,
    beta: false,
};

export function parseFeatures(value: string | undefined | null): UserFeature {
    if (!value) return { ...defaultFeatures };
    try {
        const parsed = JSON.parse(value);
        return {
            firstPartyAccess: parsed.firstPartyAccess === true,
            aneida: parsed.aneida === true,
            chat: parsed.chat === true,
            beta: parsed.beta === true,
        };
    } catch {
        return { ...defaultFeatures };
    }
}
